const LoginButtonWidth = 400;

const styles = theme => ({
    main: {
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100vh - 70px)',
        '@media(max-width:768px)': {
            height: 'calc(100vh - 70px)'
        },
        backgroundImage: `url(${theme.themeName ? `/${theme.themeName}` : '' }/background.jpg?dummy=1)`,
        backgroundSize: 'cover'
    },
    loginToolbar: {
        minHeight: 70,
        paddingLeft: 10,
        paddingRight: 10
    },
    loginTitle: {
        fontWeight: 400,
        textAlign: 'start',
        marginTop: 15,
        paddingBottom: 25,
        color: theme.palette.secondary.darkHeader
    },
    loginMessage: {
        marginBottom: 30,
        marginTop: 10
    },
    loginContent: {
        marginTop: '70px !important',
        '@media (max-width:767px)': {
            marginTop: '7px !important'
        }
    },
    panel: {
        width: LoginButtonWidth,
        backgroundColor: theme.palette.background.paper,
        borderRadius: 5,
        padding: theme.spacing(4),
        margin: '30px auto 0 10%',
        '@media (max-width:767px)': {
            margin: '10px auto auto auto'
        }
    },
    drawerPanel: {
        backgroundColor: theme.palette.header.background
    },
    drawerListItem: {
        justifyContent: 'center',
        color: theme.palette.secondary.contrastText
    },
    drawerLink: {
        color: theme.palette.secondary.contrastText,
        textAlign: 'center',
        padding: theme.spacing(2),
        textDecoration: 'none',
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
            borderRadius: 5,
            padding: theme.spacing(2),
            color: theme.palette.header.main
        }
    },
    drawerLinkActive: {
        backgroundColor: theme.palette.primary.main,
        borderRadius: 5,
        color: theme.palette.header.main,
        padding: theme.spacing(2),
        textAlign: 'center',
        textDecoration: 'none'
    },
    scanButton: {
        display: 'inline-block',
        paddingTop: 10,
        marginBottom: theme.spacing(3)
    },
    gunIcon: {
        stroke: theme.palette.primary.contrastText
    },
    loginBar: {
        background: theme.palette.header.background,
        height: 70,
        minHeight: 60,
        zIndex: 999
    },
    toolbar: theme.mixins.toolbar,
    loginContainer: {
        '@media (max-width: 340px)': {
            marginTop: theme.spacing(5)
        }
    },
    grow: {
        flexGrow: 1
    },
    loginBarText: {        
        color: theme.palette.secondary.contrastText,
        fontWeight: 400,
        padding: theme.spacing(2),
        paddingLeft: 0,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontSize: 20
    },
    loginIcon: {
        marginRight: theme.spacing(1)
    },
    logo: {
        height: 57
    },
    footer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: theme.palette.header.main
    },
    footerWithImages: {
        justifyContent: 'space-between',
        '@media (max-width: 1200px)': {
            justifyContent: 'center'
        }
    },
    footerImage: {
        maxHeight:50,
        '@media (max-width: 1200px)': {
            display: 'none'
        }
    },
    footerUl: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start'
    },
    headerUL: {
        display: 'flex',
        flexGrow: 1,
        flexDirection: 'row',
        justifyContent: 'center'
    },
    firstWord: {
        color: theme.palette.secondary.main
    }
});

export default styles;